import { Routes, Route } from 'react-router-dom'
import { Layout } from './components/layout/Layout'
import HomePage from './pages/HomePage'
import AboutPage from './pages/AboutPage'
import ContactPage from './pages/ContactPage'
import ServicesPage from './pages/ServicesPage'
import ServicePage from './pages/ServicePage'
import InsightsPage from './pages/InsightsPage'
import InsightDetailPage from './pages/InsightDetailPage'
import CaseStudyPage from './pages/CaseStudyPage'
import CaseStudyDetailPage from './pages/CaseStudyDetailPage'
import PrivacyPage from './pages/PrivacyPage'
import TermsPage from './pages/TermsPage'
import RefundPage from './pages/RefundPage'
import ClientsPage from './pages/ClientsPage'
import CityPage from './pages/CityPage'
import NotFoundPage from './pages/NotFoundPage'
import AdminApp from './admin/AdminApp'

function App() {
  return (
    <Routes>
      <Route path="/admin/*" element={<AdminApp />} />

      <Route path="/" element={<Layout />}>
        <Route index element={<HomePage />} />
        <Route path="about" element={<AboutPage />} />
        <Route path="contact" element={<ContactPage />} />
        <Route path="services" element={<ServicesPage />} />
        <Route path="services/:slug" element={<ServicePage />} />
        <Route path="insights" element={<InsightsPage />} />
        <Route path="insights/:slug" element={<InsightDetailPage />} />
        <Route path="case-study" element={<CaseStudyPage />} />
        <Route path="case-study/:slug" element={<CaseStudyDetailPage />} />
        <Route path="privacy" element={<PrivacyPage />} />
        <Route path="terms" element={<TermsPage />} />
        <Route path="refund" element={<RefundPage />} />
        <Route path="clients" element={<ClientsPage />} />
        <Route path="digital-marketing-agency-surat" element={<CityPage />} />
        <Route path="digital-marketing-agency-mumbai" element={<CityPage />} />
        <Route path="digital-marketing-agency-navi-mumbai" element={<CityPage />} />
        <Route path="digital-marketing-agency-bangalore" element={<CityPage />} />
        <Route path="digital-marketing-agency-hyderabad" element={<CityPage />} />
        <Route path="digital-marketing-agency-silvassa" element={<CityPage />} />
        <Route path="digital-marketing-agency-vapi" element={<CityPage />} />
        <Route path="digital-marketing-agency-valsad" element={<CityPage />} />
        <Route path="digital-marketing-agency-ahmedabad" element={<CityPage />} />
        <Route path="digital-marketing-agency-gandhinagar" element={<CityPage />} />
        <Route path="digital-marketing-agency-vadodara" element={<CityPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  )
}

export default App
